import { FC } from "react";

import { useTranslate } from "@/common/hooks/useTranslate";
import { DashboardButton } from "@/dashboard-design-system/DashboardButton";
import {
  DashboardDialog,
  DashboardDialogBody,
  DashboardDialogContent,
  DashboardDialogFooter,
  DashboardDialogHeader,
} from "@/dashboard-design-system/DashboardDialog";
import { DashboardTypography } from "@/dashboard-design-system/Typography";

interface TransferPurchasesToDateDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void>;
  formattedDate: string;
}

export const TransferPurchasesToDateDialog: FC<TransferPurchasesToDateDialogProps> = ({
  open,
  onClose,
  onConfirm,
  formattedDate,
}) => {
  const { t } = useTranslate();

  return (
    <DashboardDialog open={open} onClose={onClose} vibe="warning" maxWidth="sm">
      <DashboardDialogBody
        slots={{
          header: <DashboardDialogHeader title={t("dashboard", "ticketing.transferPurchasesToDateDialog.title")} />,
          content: (
            <DashboardDialogContent>
              <DashboardTypography variant="body2" vibe="text-neutral-moderate">
                {t("dashboard", "ticketing.transferPurchasesToDateDialog.body", { date: formattedDate })}
              </DashboardTypography>
            </DashboardDialogContent>
          ),
          footer: (
            <DashboardDialogFooter>
              <DashboardButton onClick={onConfirm}>
                {t("dashboard", "ticketing.transferPurchasesToDateDialog.confirmButton")}
              </DashboardButton>
              <DashboardButton onClick={onClose}>{t("common", "cancel")}</DashboardButton>
            </DashboardDialogFooter>
          ),
        }}
      />
    </DashboardDialog>
  );
};
